<template>
  <div>
    <div class="clearfix">
      <div class="float-left page-title my-3">
        NCS 훈련 과정 관리
        <small style="font-size:16px">
          <span class="ml-4 bolder">기준 연도:</span>
          <select v-model="baseYear" class="select-underline">
            <option v-for="(year, i) in baseYears" :key="i">{{year}}</option>
          </select>
        </small>
      </div>
      <div class="float-right text-right">
        <mdb-btn icon="plus" class="p-1" @click="onAdd">추가</mdb-btn>
      </div>
    </div>
    <div v-if="baseYear">
      <div v-for="(training, i) in trainings[baseYear]" :key="i">
        <span v-if="training.code"> {{training.code}} /</span>
        <span class="pointer" @click="onSelectTraining(training)">{{training.name}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
export default {
  name: 'StaffNcsTrainingPage',
  components: { },
  props: [],
  data: () => ({
    TAG: 'StaffNcsTrainingPage',
    // org: '58115a01329d5c29b85a5e5e', // 테스트용
    trainings: {},
    baseYear: ''
  }),
  computed: {
    ...mapState('auth', ['profile', 'org']),
    ...mapGetters('auth', ['training', 'isStaff']),
    baseYears () {
      return Object.keys(this.trainings).sort().reverse()
    }
  },
  methods: {
    async load () {
      this.baseYear = this.$route.query.baseYear
      if (!this.org._id) return
      this.trainings = await NcsTraining.get({ org: this.org._id })
    },
    onAdd () {
      this.$router.push({ name: 'StaffNcsTrainingDetailPage', query: { org: this.org._id } }) // 테스트용 org 구성 수정요
    },
    onSelectTraining (training) {
      this.$router.push({ name: 'StaffNcsTrainingDetailPage', query: { ncstraining: training._id, org: this.org._id } })
    }
  },
  watch: {
    org: 'load',
    baseYear () {
      if (this.baseYear !== this.$route.query.baseYear) {
        this.$router.replace({ name: 'StaffNcsTrainingPage', query: { baseYear: this.baseYear } })
      }
    }
  },
  created () { this.load() }
}
</script>
